import { featureFlags } from "@/config/features";

export const DAILY_RENDER_LIMITS = {
  free: {
    short: "3/day",
    full: "3 renders per day",
  },
  starter: {
    short: "25/day",
    full: "25 renders per day",
  },
  pro: {
    short: "100/day",
    full: "100 renders per day",
  },
  studio: {
    short: "500/day",
    full: "500 renders per day",
  },
} as const;

export const MARKETING_HERO_STATS = [
  {
    id: "free",
    // Gated by NEXT_PUBLIC_MONETIZATION_GATE: paid gate shows the 3-day trial
    // badge; free-to-start (default) shows the free daily-render badge.
    title: featureFlags.enablePaidGate ? "3-Day" : "Free",
    label: featureFlags.enablePaidGate ? "Free Trial" : DAILY_RENDER_LIMITS.free.short,
  },
  {
    id: "speed",
    title: "60s",
    label: "Avg Render",
  },
  {
    id: "quality",
    title: "4K",
    label: "Max Quality",
  },
  {
    id: "custom",
    title: "Custom",
    label: "Tailored",
  },
] as const;

export type MarketingHeroStatId = (typeof MARKETING_HERO_STATS)[number]["id"];
